import * as React from "react";
import SvgIcon from "@material-ui/core/SvgIcon";

const SvgI24Users = props => {
  return (
    <SvgIcon {...props}>
      <path d="M12 10a3 3 0 100-6 3 3 0 000 6zm0 2a5 5 0 100-10 5 5 0 000 10zM9 16a4 4 0 00-4 4v1a1 1 0 11-2 0v-1a6 6 0 016-6h6a6 6 0 016 6v1a1 1 0 11-2 0v-1a4 4 0 00-4-4H9z" />
    </SvgIcon>
  );
};

export default SvgI24Users;
